import { render, staticRenderFns } from "./createEmailTemplateModal.vue?vue&type=template&id=95327c1a"
import script from "./createEmailTemplateModal.vue?vue&type=script&lang=js"
export * from "./createEmailTemplateModal.vue?vue&type=script&lang=js"
import style0 from "./createEmailTemplateModal.vue?vue&type=style&index=0&id=95327c1a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports